import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';

import SectionCard from '../../../positionTemplate/components/SectionCard';
import AutoSaveTextField from '../AutoSaveTextField';
import SectionTitle from '../SectionTitle';

const contentSx = { display: 'flex', flexDirection: 'column', gap: '16px', padding: '8px 0' };

const PositionDetailsCard = ({ positionTemplate, saveField, getStatus }) => {
  const intl = useIntl();

  return (
    <SectionCard
      header={
        <SectionTitle>{intl.formatMessage({ id: 'pt.detail.positionDetails' })}</SectionTitle>
      }
    >
      <Box sx={contentSx}>
        <AutoSaveTextField
          id="pt-detail-name"
          label={intl.formatMessage({ id: 'pt.detail.positionName' })}
          helperText={intl.formatMessage({ id: 'pt.detail.positionName.helper' })}
          value={positionTemplate.name}
          status={getStatus('name')}
          validate={(value) =>
            value.trim() ? null : intl.formatMessage({ id: 'pt.detail.positionName.required' })
          }
          onSave={(name) => {
            const trimmed = name.trim();
            saveField({ key: 'name', fields: { name: trimmed }, patch: { name: trimmed } });
          }}
        />
        <AutoSaveTextField
          id="pt-detail-description"
          label={intl.formatMessage({ id: 'pt.detail.description' })}
          helperText={intl.formatMessage({ id: 'pt.detail.description.helper' })}
          value={positionTemplate.description}
          status={getStatus('description')}
          multiline
          minRows={5}
          showCharacterCount
          onSave={(description) =>
            saveField({ key: 'description', fields: { description }, patch: { description } })
          }
        />
      </Box>
    </SectionCard>
  );
};

PositionDetailsCard.propTypes = {
  positionTemplate: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  saveField: PropTypes.func.isRequired,
  getStatus: PropTypes.func.isRequired,
};

export default PositionDetailsCard;
